<template>
  <div class="con">
    <img class="chairman" src="@/assets/company/chairman.jpg" />
    <p id="title">董事长，党支部书记，总工程师：王世有</p>
    <InfoCard
      class="InfoCard"
      v-bind:style_blue="true"
      v-bind="info_post"
    ></InfoCard>
    <InfoCard
      class="InfoCard"
      v-bind:style_blue="true"
      v-bind="info_honour"
    ></InfoCard>
    <InfoCard
      class="InfoCard"
      v-bind:style_blue="true"
      v-bind="info_success"
    ></InfoCard>
    <InfoCard
      class="InfoCard"
      v-bind:style_blue="true"
      v-bind="info_mind"
    ></InfoCard>
    <img class="chairman scientist" src="@/assets/company/scientist.png" />
    <img class="chairman scientist" src="@/assets/company/teacher.png" />
    <img class="chairman scientist" src="@/assets/company/doctor.jpg" />
		<img class="chairman scientist" src="@/assets/company/scientist2.jpg" />
    <img class="chairman scientist" src="@/assets/company/group.jpg" />
  </div>
</template>

<style scoped>
.con {
  text-align: center;
}
.chairman {
  max-width: 100%;
}
#title {
  font-size: 20px;
  padding: 16px 0;
  color: #303133;
}
.InfoCard {
  max-width: 800px;
  width: calc(100% - 64px);
  margin: 16px auto;
}
.scientist {
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
  margin-top: 32px;
  margin-left: auto;
  margin-right: auto;
  display: block;
}
</style>

<script>
/*董事长简介模块*/
import InfoCard from "@/components/company/InfoCard.vue";
export default {
  components: {
    InfoCard
  },
  data() {
    return {
      info_post: {
        title: "创新事迹简介",
        arr: [
          `
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;大连世有电力科技有限公司（原大连市金州仪器仪表厂）董事长、党支部书记、总工程师、教授级高工、省级企业技术中心主任、大连市输变电智能监控工程实验室主任、中国电器工业协会理事、中国科学家论坛副理事长：<span style="font-size: 26px; color: #409EFF">王世有</span>。他潜心于高精专科研项目的研究开发，现已成功开发出光纤测温装置、光纤温控器、变压器油光声光谱在线监测装置、变压器油中溶解气体在线监测装置、变压器智能综合在线监测分析IED单元、局部放电在线监测系统、铁芯接地电流在线监测系统、避雷器在线监测系统、容性设备在线监测系统、配电自动化智能终端监控系统、输电线路在线监测系统、智能设备状态监测系统、绕组温控器、油面温控器、油位计、无线式在线温度监测装置、变压器油色谱载气模块、SF6密度及微水在线监测系统、热值监测仪、烟气监测装置等高新技术产品。取得几十项国家专利，其中发明专利9项，是7项国家机械行业标准主要起草人之一，是输变电用仪器仪表行业的领军人物。研发的产品获得大连市科技成果一等奖、省市科技成果二等奖，辽宁省电力科学技术进步奖、辽宁省专精特新中小企业、辽宁省专精特新产品奖、大连市专利奖三等奖、中国创新创业大赛大连赛区二等奖。公司在他的领导下被评定为国家级高新技术企业、辽宁省省级企业技术中心、“金利”商标被认定为“中国驰名商标”。“王世有劳模创新工作室”，被评为大连市示范性劳模创新工作室。
          `
          // "大连世有电力科技有限公司董事长",
          // "大连世有电力科技有限公司党支部书记",
          // "大连世有电力科技有限公司总工程师",
          // "中国管理科学研究院商学院客座教授",
        ]
      },
      info_honour: {
        title: "所获荣誉",
        arr: [
          `
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2010年他主持编写的《坚持以人为本、构建合谐社会》论文被评为“中国中小企业优秀创新成果企业”，“中国自主创新百强企业”，2010年他参加中国电工装备创新与发展论坛，主持研发的智能化产品局放在线监测系统获“中国十大电气创新产品”。
          他于2006年12月被评为大连市首届优秀工程师， 2007年被评为大连市科技项目评审专家； 
          2011年荣获大连市“五一”奖章；2012年被评为大连市劳动模范，大连市人大代表、大连市工商联常委，
          2019年被中国管理科学研究院聘任客座教授、第十六届“中国科学家论坛副理事长”、 “2019年中国科技创新领军人物”、“世有”品牌被授予“2019年中国科技创新品牌”、 “辽宁省瞪羚企业”、“2019年度国家知识产权优势企业”称号等。
          `
        ]
      },
      info_success: {
        title: "企业家在企业创新工作中所做出的贡献",
        arr: [
          `
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;在长期企业技术创新工作中，践行科学发展观，坚持以人为本，自主研发、追求卓越，开发出百余种变压器在线监测系统及测温保护装置，
          成功应用于电气化铁路、核电站、超高压、智能电网、大数据、物联网大数据等国家重点工程。
          30余年的行业技术创新成果的积累，科技创新拓进步伐突飞猛进，积淀和丰富了的研发项目组织、深层次领域探索的经验。
          能够准确把握行业及产品的技术发展需求的方向，始终把技术创新能力视为公司发展的根基。
          `
        ]
      },
      info_mind: {
        title: "理念",
        arr: [
          `
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;王世有是一个善于学习思考的领导者，
          亲自提出了只要员工在科技创新中奋斗，
          “奋斗才会有幸福、创新令人最风流”
          “三天改变态度，三月改变业绩，三年改变人生”、
          “能干工作的人是合格的，用心工作的人是优秀的”、
          “员工要体面工作，有尊严的生活”，
          “企业发展与员工利益共享”
          等企业文化理念，
          用以培养和规范职工的言行。
          这种人性化关心员工的理念，
          产生了凝聚人心创造性效应。
          `
        ]
      }
    };
  }
};
</script>
